import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';

import rootReducer from '../reducers';

const shareStateTree = (store) => (next) => (action) => {
  const stateTree = store.getState();
  next({ ...action, stateTree });
};

const configureStore = () => createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(thunkMiddleware, shareStateTree)
  )
)

export default configureStore;
